module.exports = __webpack_public_path__ + "static/img/post_4.76666c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/posts/post_4.png
// module id = SLA0
// module chunks = 0